export class PagingInfo {
    curPage:number = 1;/** 현재 페이지 **/
    curRange:number = 1;/** 현재 블럭(range) **/
    endPage:number = 1;/** 끝 페이지 **/
    listCnt:number = 0;/** 총 게시글 수 **/
    listItems:any[] = undefined;
    listPageNumber:number[] = undefined;
    nextPage:number = undefined;/** 다음 페이지 **/
    pageCnt:number = 0;/** 총 페이지 수 **/
    pageSize:number = 10;/** 한 페이지당 게시글 수 **/
    prevPage:number = undefined;/** 이전 페이지 **/
    rangeCnt:number = undefined;/** 총 블럭(range) 수 **/
    rangeSize:number = 10;/** 한 블럭(range)당 페이지 수 **/
    searchOptions:any = undefined;
    sortField:string = undefined;
    sortType:string = "asc";
    startIndex:number = 0;/** 시작 index **/
    startPage:number = 1;/** 시작 페이지 **/

    hasNextPage:boolean = false;
    hasPrevPage:boolean = false;

    countStatusAll:number = 0;
    countStatusOn:number = 0;
    countStatusOff:number = 0;
    countStatusError:number = 0;

    setPageCnt(listCnt:number) {
        this.pageCnt = Math.ceil(listCnt*1.0/this.pageSize);
    }
    setRangeCnt(pageCnt:number) {
        this.rangeCnt = Math.ceil(pageCnt*1.0/this.rangeSize);
    }
    rangeSetting(curPage:number){
        this.setCurRange(curPage);
        this.startPage = (this.curRange - 1) * this.rangeSize + 1;
        this.endPage = this.startPage + this.rangeSize - 1;

        if(this.endPage > this.pageCnt){
            this.endPage = this.pageCnt;
        }

        this.prevPage = curPage - 1;
        this.nextPage = curPage + 1;
    }
    setCurRange(curPage:number) {
        this.curRange = Math.floor((curPage-1)/this.rangeSize) + 1;
    }
    setStartIndex(curPage:number) {
        this.startIndex = (curPage-1) * this.pageSize;
    }
    calcPaging() {
        console.log("calcPaging",this);
        /**
         * 페이징 처리 순서
         * 1. 총 페이지수
         * 2. 총 블럭(range)수
         * 3. range setting
         */

        /** 1. 총 페이지 수 **/
        this.setPageCnt(this.listCnt);
        /** 2. 총 블럭(range)수 **/
        this.setRangeCnt(this.pageCnt);
        /** 3. 블럭(range) setting **/
        this.rangeSetting(this.curPage);
        /** DB 질의를 위한 startIndex 설정 **/
        this.setStartIndex(this.curPage);
    }
}
